import ajaxService from "AjaxService";
import { AsyncDictionary } from "AsyncDictionary";
import global from "Global";
import userSession from "UserSession";
import { UserType } from "UserTypeConstants";

const promiseCache = new AsyncDictionary<boolean>();
const valueCache = new Map<string, boolean>();

export function cachedHasAccessForBranch(checkpoint: string, companyPK: string, branchPK: string): boolean | undefined {
  return valueCache.get(`branch_${checkpoint}_${companyPK}_${branchPK}`);
}

export async function hasAccessForBranchAsync(
  checkpoint: string,
  companyPK: string,
  branchPK: string,
): Promise<boolean> {
  if (userSession.sessionData().userType !== UserType.Staff) {
    return false;
  }

  const cacheKey = `branch_${checkpoint}_${companyPK}_${branchPK}`;
  return await promiseCache.getOrAddAsync(cacheKey, async () => {
    const result = await ajaxService.getAsync<boolean>(global.serviceUri + "api/security/hasAccessForBranch", {
      checkpoint,
      companyPK,
      branchPK,
    });

    valueCache.set(cacheKey, result);
    return result;
  });
}

export function cachedHasAccessForBranchDepartment(
  checkpoint: string,
  companyPK: string,
  branchPK: string,
  departmentPK: string,
): boolean | undefined {
  return valueCache.get(`branchDepartment_${checkpoint}_${companyPK}_${branchPK}_${departmentPK}`);
}

export async function hasAccessForBranchDepartmentAsync(
  checkpoint: string,
  companyPK: string,
  branchPK: string,
  departmentPK: string,
): Promise<boolean> {
  if (userSession.sessionData().userType !== UserType.Staff) {
    return false;
  }

  const cacheKey = `branchDepartment_${checkpoint}_${companyPK}_${branchPK}_${departmentPK}`;
  return await promiseCache.getOrAddAsync(cacheKey, async () => {
    const result = await ajaxService.getAsync<boolean>(
      global.serviceUri + "api/security/hasAccessForBranchDepartment",
      {
        checkpoint,
        companyPK,
        branchPK,
        departmentPK,
      },
    );

    valueCache.set(cacheKey, result);
    return result;
  });
}

export function cachedHasAccessForCompany(checkpoint: string, companyPK: string): boolean | undefined {
  return valueCache.get(`company_${checkpoint}_${companyPK}`);
}

export async function hasAccessForCompanyAsync(checkpoint: string, companyPK: string): Promise<boolean> {
  if (userSession.sessionData().userType !== UserType.Staff) {
    return false;
  }

  const cacheKey = `company_${checkpoint}_${companyPK}`;
  return await promiseCache.getOrAddAsync(cacheKey, async () => {
    const result = await ajaxService.getAsync<boolean>(global.serviceUri + "api/security/hasAccessForCompany", {
      checkpoint,
      companyPK,
    });

    valueCache.set(cacheKey, result);
    return result;
  });
}

export function cachedHasAccessForCompanyDepartment(
  checkpoint: string,
  companyPK: string,
  departmentPK: string,
): boolean | undefined {
  return valueCache.get(`companyDepartment_${checkpoint}_${companyPK}_${departmentPK}`);
}

export async function hasAccessForCompanyDepartmentAsync(
  checkpoint: string,
  companyPK: string,
  departmentPK: string,
): Promise<boolean> {
  if (userSession.sessionData().userType !== UserType.Staff) {
    return false;
  }

  const cacheKey = `companyDepartment_${checkpoint}_${companyPK}_${departmentPK}`;
  return await promiseCache.getOrAddAsync(cacheKey, async () => {
    const result = await ajaxService.getAsync<boolean>(
      global.serviceUri + "api/security/hasAccessForCompanyDepartment",
      {
        checkpoint,
        companyPK,
        departmentPK,
      },
    );

    valueCache.set(cacheKey, result);
    return result;
  });
}

export function clearCache(): void {
  valueCache.clear();
  promiseCache.clear();
}
